import { Component, input, effect, inject, ElementRef, signal } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { HttpClient } from "@angular/common/http";
import DOMPurify from "dompurify";
import { Subscription } from "rxjs";

@Component({
  selector: "icon",
  imports: [],
  templateUrl: "./icon.html",
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      div {
        display: inline-flex;
        line-height: 0;
      }

      :host ::ng-deep svg {
        width: 100%;
        height: 100%;
      }
    `,
  ],
  standalone: true,
})
export class Icon {
  name = input.required<string>();
  size = input<string>("1.5rem");
  color = input<string>("text-inherit");

  svgContent = signal<SafeHtml>("");

  private readonly http = inject(HttpClient);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly elementRef = inject(ElementRef<HTMLElement>);

  constructor() {
    effect((onCleanup) => {
      const subscription = this.loadIcon(this.name());
      onCleanup(() => subscription.unsubscribe());
    });

    effect(() => {
      const host = this.elementRef.nativeElement;
      host.style.width = this.size();
      host.style.height = this.size();
    });
  }

  private loadIcon(iconName: string): Subscription {
    return this.http.get(`assets/icons/${iconName}.svg`, { responseType: "text" }).subscribe({
      next: (svg) => {
        const clean = DOMPurify.sanitize(svg, { USE_PROFILES: { svg: true, svgFilters: true } });
        this.svgContent.set(this.sanitizer.bypassSecurityTrustHtml(clean)); // NOSONAR - Content is explicitly sanitized by DOMPurify before being marked as trusted
      },
      error: () => this.svgContent.set(""),
    });
  }
}
